import { render, staticRenderFns } from "./OrderPc.vue?vue&type=template&id=a29156c2&scoped=true"
import script from "./OrderPc.vue?vue&type=script&lang=js"
export * from "./OrderPc.vue?vue&type=script&lang=js"
import style0 from "./OrderPc.vue?vue&type=style&index=0&id=a29156c2&prod&lang=css"
import style1 from "./OrderPc.vue?vue&type=style&index=1&id=a29156c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29156c2",
  null
  
)

export default component.exports